// @flow

import React, { Component } from 'react';
import type { Node } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const PageWrapper = styled.div`
  background: white;
`;

type Props = {
  children: Node,
  title?: string
}

class Page extends Component<Props> {

  render() {
    const { children, title } = this.props;

    return (
      <PageWrapper>
        <Helmet title={title} />
        {children}
      </PageWrapper>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js